import React, { useCallback, useContext, useMemo } from "react"
import classNames from "classnames"
import dayjs from "dayjs"
import { SafeAreaView } from "@hg/layouts"

import { GlobalContext } from "@/topic/rogue_4/context"
import { useGameStore } from "../../store"
import { useGameRollModal } from "../Modal/store"

import styles from "./index.module.less"

interface IProps {
    visible?: boolean
    className?: string
    onBack?: () => void
}

const GameMenu: React.FC<IProps> = (props) => {
    const { visible, className, onBack } = props

    const {
        state: { bgm },
        dispatch,
    } = useContext(GlobalContext)

    const handleClickLogin = useCallback(() => {
        if (visible) {
            dispatch({
                type: "updateContext",
                payload: {
                    showRegistry: true,
                },
            })
        }
    }, [dispatch, visible])

    const handleClickHome = useCallback(() => {
        if (visible) {
            onBack?.()
        }
    }, [onBack, visible])

    const handleClickMusic = useCallback(() => {
        if (visible) {
            dispatch({
                type: "updateContext",
                payload: {
                    bgm: !bgm,
                },
            })
        }
    }, [visible, dispatch, bgm])

    const callRollModal = useGameRollModal()
    const rolled = useGameStore((state) => state.rolled)

    const isFillEnd = useMemo(() => {
        const now = dayjs().unix()
        return now > __ROGUE_4_LOTTERY_FILL_END_AT
    }, [])

    return (
        <SafeAreaView
            mode="margin"
            edges={["right"]}
            className={classNames(styles.menu, className)}
        >
            {rolled && !isFillEnd ? (
                <div
                    className={classNames(styles.menuItem, styles.gift)}
                    onClick={(e) => {
                        e.stopPropagation()
                        callRollModal()
                    }}
                >
                    <div className={styles.icon} />
                </div>
            ) : null}
            {/* <div
                className={classNames(styles.menuItem, styles.login)}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickLogin()
                }}
            >
                <div className={styles.icon} />
            </div> */}
            <div
                className={classNames(styles.menuItem, styles.home)}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickHome()
                }}
            >
                <div className={styles.icon} />
            </div>
            <div
                className={classNames(
                    styles.menuItem,
                    styles.bgm,
                    !bgm && styles.off
                )}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickMusic()
                }}
            >
                <div className={styles.icon} />
            </div>
        </SafeAreaView>
    )
}

export default GameMenu
